import { render, staticRenderFns } from "./ProfileEmergency.vue?vue&type=template&id=3e846ae3&"
import script from "./ProfileEmergency.vue?vue&type=script&lang=js&"
export * from "./ProfileEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports